// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1vR49","title":"InfoRow_title__2wA4h"};